// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-group-title[data-v-364d61e9]{font-size:14px;padding:10px 0;cursor:pointer}.option-group-title .right-btn[data-v-364d61e9]{float:right}.optColorItemAdd[data-v-364d61e9]{display:inline-block;width:32px;height:32px;margin-right:5px;border:1px solid #ddd;vertical-align:top;text-align:center;border-radius:4px}", ""]);
// Exports
module.exports = exports;
